import { Form, Input, Select, Button } from "antd";

import {
  UserData,
} from "../../model/model";

import { onFinishFailed } from "../helpers";

interface IProps {
  initialValues: UserData;
  onFinish: (obj: UserData, password: string) => void;
  password: boolean;
  update?: boolean;
}

interface UserWithPassword extends UserData {
  password: string;
}

function UserForm(props: IProps) {
  const onFinish = (v: UserWithPassword) => {
    const values = Object.assign(props.initialValues, v);

    const userData :UserData = {
      login: values.login,
          email: values.email,
          name: values.name,
          role: values.role,
          pass: values.password,
          subId: values.subId,
          orgId: values.orgId,
          siteId: values.siteId,
          lastSeenAt: 0,
    };
   
    props.onFinish(userData, v.password);
  };

  return (
    <Form
      layout="vertical"
      initialValues={props.initialValues}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
      <Form.Item label="Login" name="login" rules={[{ required: true, message: "Please enter login!" }]}>
        <Input  disabled={props.update}/>
      </Form.Item>
      <Form.Item label="Email" name="email" rules={[{ required: true, message: "Please enter an email address!" }]}>
        <Input />
      </Form.Item>
      {props.password && (
        <Form.Item label="Password" name="password" rules={[{ required: true, message: "Please enter a password!" }]}>
          <Input type="password" />
        </Form.Item>
      )}
       <Form.Item label="Role" name="role" rules={[{ required: true, message: "Please select a userData role!" }]}>
            <Select > 
              <Select.Option value='Viewer'>Viewer</Select.Option>
              <Select.Option value='Editor'>Editor</Select.Option>
              <Select.Option value='Admin'>Admin</Select.Option>
            </Select>
       </Form.Item>
              <Form.Item label="Name" name="name"  rules={[{ required: true, message: "Please enter an name!" }]}>
        <Input.TextArea />
      </Form.Item>
      

      <Form.Item>
        <Button type="primary" htmlType="submit">
          Submit
        </Button>
      </Form.Item>
    </Form>
  );
}

export default UserForm;
